import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CompetentAuthorityModel} from '../../../../shared/models/competent-authority.model';
import {AnimalSheltersRepository} from 'src/app/shared/states/animal-shelter.repository';
import {take} from 'rxjs';
import {ContactModel} from '../../models/contact.model';
import {AuthorityContactService} from '../../Service/authority-contact.service';

@Component({
  selector: 'app-competent-authority-create-dialog',
  standalone: false,
  templateUrl: './competent-authority-create-dialog.component.html',
  styleUrls: ['./competent-authority-create-dialog.component.scss']
})
export class CompetentAuthorityCreateDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() created = new EventEmitter<CompetentAuthorityModel>();
  authority: CompetentAuthorityModel = {
    name: '',
    animalShelter: {id: 0}
  } as CompetentAuthorityModel;
  newContact: ContactModel = {} as ContactModel;
  validationStatusChanged: any;

  constructor(
    private readonly _animalShelterRepo: AnimalSheltersRepository,
    private readonly _authorityContactService: AuthorityContactService
  ) {
  }

  create(authority: CompetentAuthorityModel): void {
    const shelter = this._animalShelterRepo.getActiveAnimalShelter();
    if (!shelter) {
      return;
    }

    this._authorityContactService.createAuthorityWithContact(authority, this.newContact, shelter.id)
      .pipe(take(1))
      .subscribe({
        next: (newAuthority) => {
          this.created.emit(newAuthority);
          this.visibleChange.emit(false);
          this.authority = {} as CompetentAuthorityModel;
          this.newContact = {} as ContactModel;
        },
        error: (err) => {
          console.error('Fehler beim Erstellen der Behörde:', err);
        }
      });
  }

  cancel(): void {
    this.visibleChange.emit(false);
  }

  onSetNewContact($event: any) {
    this.newContact = $event;
  }
}
